<main class="p-4 container-lg">
  <div class="row">
    <div class="col-12">
      <h2>GT Pro Tune - Buy Now!</h2>
      @if (isExpired){
      <p>Your subscription has expired. Please consider purchasing to continue using GT Pro Tune. You may choose from the following version levels.</p>
      }
      @else if(subscription?.subscriptionLevel == 'Trial'){
      <p>Thank you for trying GT Pro Tune. Please consider purchasing to continue using GT Pro Tune. You may choose from the following access levels.</p>
      }
      <div class="row">
        @if (subscription?.subscriptionLevel == 'Trial'){
        <div class="col-12 col-lg-4 d-lg-flex mb-3">
          <div class="card bg-secondary text-white mb-4">
            <div class="card-body">
              <h4 class="card-title">Lite</h4>
              <p class="card-text">
                Tune your suspsension and transmission with a simplifier set of of features.
              </p>

              <h5>Features</h5>
              <ul>
                <li>Full suspension tuning</li>
                <li>Basic transmisssion tuning</li>
                <li>Shift points graph</li>
                <li>Save/load settings</li>
              </ul>
            </div>
            <div class="card-footer">
              <h2 class="text-center">Cost: ${{ getProductPrice('Lite') }}</h2>
              @if(isAIEngineerSubscriptionExpired == true){
              <div class="form-group row justify-content-center">
                <div class="col-auto">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" [checked]="includeAIEngineerLite" [(ngModel)]="includeAIEngineerLite" autocomplete="off" />
                    <label for="includeAIEngineerLite" class="form-label text-center">
                      Include AI Engineer subscription for <br />${{ getProductPrice('AIEngineer') }}/month
                    </label>
                  </div>
                </div>
              </div>
              }
              <div class="form-group row">
                <div class="col text-center">
                  <button type="submit" class="btn btn-primary" (click)="updateSubscription('Lite')" [disabled]="submitted">
                    <i class="fa-solid fa-lock" [class]="{
                         'fa-lock': !submitted || selectedSubscriptionLevel != 'Lite',
                         'fa-spinner': submitted && selectedSubscriptionLevel == 'Lite',
                         'fa-spin': submitted && selectedSubscriptionLevel == 'Lite'
                         }"></i> Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-4 d-lg-flex mb-3">
          <div class="card bg-secondary text-white mb-4">
            <div class="card-body">
              <h4 class="card-title">Advanced</h4>
              <p class="card-text">
                Tune your suspsension and transmission with an advanced set of of features. Utilize each car's torque curve
                for precision gear tuning.
              </p>

              <h5>Features</h5>
              <ul>
                <li>Full suspension tuning</li>
                <li>Advanced transmisssion tuning</li>
                <li>Torque/power graph</li>
                <li>Shift points graph</li>
                <li>Tractive graph</li>
                <li>Save/load settings</li>
              </ul>
            </div>
            <div class="card-footer">
              <h2 class="text-center">Cost: ${{ getProductPrice('Advanced') }}</h2>
              @if(isAIEngineerSubscriptionExpired == true){
              <div class="form-group row justify-content-center">
                <div class="col-auto">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" [checked]="includeAIEngineerAdvanced" [(ngModel)]="includeAIEngineerAdvanced" autocomplete="off" />
                    <label for="includeAIEngineerAdvanced" class="form-label text-center">
                      Include AI Engineer subscription for <br />${{ getProductPrice('AIEngineer') }}/month
                    </label>
                  </div>
                </div>
              </div>
              }
              <div class="form-group row">
                <div class="col text-center">
                  <button type="submit" class="btn btn-primary" (click)="updateSubscription('Advanced')" [disabled]="submitted">
                    <i class="fa-solid fa-lock" [class]="{
                         'fa-lock': !submitted || selectedSubscriptionLevel != 'Advanced',
                         'fa-spinner': submitted && selectedSubscriptionLevel == 'Advanced',
                         'fa-spin': submitted && selectedSubscriptionLevel == 'Advanced'
                         }"></i> Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        }

        @if(subscription?.subscriptionLevel == 'Lite'){
        <div class="col-12 col-lg-4 d-lg-flex mb-3">
          <div class="card bg-secondary text-white mb-4">
            <div class="card-body">
              <h4 class="card-title">Advanced Upgrade</h4>
              <p class="card-text">
                Tune your suspsension and transmission with an advanced set of of features. Utilize each car's torque curve
                for precision gear tuning.
              </p>

              <h5>Features</h5>
              <ul>
                <li>Full suspension tuning</li>
                <li>Advanced transmisssion tuning</li>
                <li>Torque/power graph</li>
                <li>Shift points graph</li>
                <li>Tractive graph</li>
                <li>Save/load settings</li>
              </ul>
            </div>
            <div class="card-footer">
              <h2 class="text-center">Cost: $19.99</h2>
              @if(isAIEngineerSubscriptionExpired == true){
              <div class="form-group row justify-content-center">
                <div class="col-auto">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" [checked]="advancedWithAIEngineer" [(ngModel)]="advancedWithAIEngineer" autocomplete="off" />
                    <label for="includeAIEngineer" class="form-label text-center">
                      Include AI Engineer subscription for <br />$1.99/month
                    </label>
                  </div>
                </div>
              </div>
              }
              <div class="form-group row">
                <div class="col text-center">
                  <button type="submit" class="btn btn-primary" (click)="updateSubscription('Upgrade')" [disabled]="submitted">
                    <i class="fa-solid fa-lock" [class]="{
                  'fa-lock': !submitted || selectedSubscriptionLevel != 'Upgrade',
                  'fa-spinner': submitted && selectedSubscriptionLevel == 'Upgrade',
                  'fa-spin': submitted && selectedSubscriptionLevel == 'Upgrade'
                  }"></i> Upgrade Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        }

        @if(subscription?.subscriptionLevel != 'Trial' && isAIEngineerSubscriptionExpired == true){
        <div class="col-12 col-lg-4 d-lg-flex mb-3">
          <div class="card bg-secondary text-white mb-4">
            <div class="card-body">
              <h4 class="card-title">AI Engineer</h4>
              <p class="card-text">
                Subscribe to AI Engineer and get the power of AI to help tune your cars.
              </p>

              <h5>Features</h5>
              <ul>
                <li>Access to AI Engineer</li>
              </ul>
            </div>
            <div class="card-footer">
              <h2 class="text-center">Cost: ${{ getProductPrice('AIEngineer') }}/month</h2>
              <div class="form-group row">
                <div class="col text-center">
                  <button type="submit" class="btn btn-primary" (click)="updateSubscription('AIEngineer')" [disabled]="submitted">
                    <i class="fa-solid fa-lock" [class]="{
               'fa-lock': !submitted || selectedSubscriptionLevel != 'AIEngineer',
               'fa-spinner': submitted && selectedSubscriptionLevel == 'AIEngineer',
               'fa-spin': submitted && selectedSubscriptionLevel == 'AIEngineer'
               }"></i> Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</main>
